import { isDateTbd } from '@wix/wix-events-commons-statics';
import { getDiffInHours, getMomentDate, now } from './date';
import { formatDates, getFullDate, getShortDate, getTime, isYearHidden } from './formatter';
export var getFormattedStartDate = function (event, fullLocale) {
    var _a = event.scheduling.config, scheduleTbdMessage = _a.scheduleTbdMessage, scheduleTbd = _a.scheduleTbd, startDate = _a.startDate, timeZoneId = _a.timeZoneId, showTimeZone = _a.showTimeZone;
    if (scheduleTbd) {
        return scheduleTbdMessage;
    }
    var showYear = !isYearHidden(getMomentDate(startDate, timeZoneId), undefined);
    return getFullDate(startDate, timeZoneId, showYear, fullLocale, showTimeZone);
};
export var getFormattedShortStartDate = function (event, fullLocale) {
    var _a = event.scheduling.config, scheduleTbdMessage = _a.scheduleTbdMessage, scheduleTbd = _a.scheduleTbd, startDate = _a.startDate, timeZoneId = _a.timeZoneId;
    if (scheduleTbd) {
        return scheduleTbdMessage;
    }
    return getShortDate(startDate, timeZoneId, fullLocale);
};
export var getFormattedStartTime = function (event, fullLocale) {
    var config = event.scheduling.config;
    return getTime(config.startDate, config.timeZoneId, fullLocale);
};
export var getFormattedFullDate = function (event, fullLocale, showYear) {
    if (showYear === void 0) { showYear = false; }
    var _a = event.scheduling.config, scheduleTbd = _a.scheduleTbd, scheduleTbdMessage = _a.scheduleTbdMessage, startDate = _a.startDate, endDate = _a.endDate, endDateHidden = _a.endDateHidden, timeZoneId = _a.timeZoneId, showTimeZone = _a.showTimeZone;
    return scheduleTbd
        ? scheduleTbdMessage
        : formatDates(startDate, endDateHidden ? null : endDate, timeZoneId, showYear, fullLocale, showTimeZone);
};
export var getDaysToEvent = function (event) {
    var days = 0;
    var HOURS_PER_DAY = 24;
    if (!isDateTbd(event)) {
        var start = getMomentDate(event.scheduling.config.startDate, event.scheduling.config.timeZoneId);
        var hours = Math.floor(getDiffInHours(start, now(event.scheduling.config.timeZoneId)));
        days = Math.ceil((hours - start.hour()) / HOURS_PER_DAY);
    }
    return days < 0 ? 0 : days;
};
//# sourceMappingURL=event-selectors.js.map